import React, { useEffect, useState } from 'react'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect, useDispatch } from 'react-redux'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { Col, Row, Space } from 'antd'
import { LoadingView } from 'Components/modal'
import styled from 'styled-components'
import { QuaterPickerItem, RangeDateItem, SelectItem } from 'Components/form'
import { SearchOutlined } from '@ant-design/icons'
import { PrimaryButton } from 'Components/button'
import { currentDate, getLast1Month, getMenuSelect, renderDateFormQuater, toDateQuery } from 'helpers/format'
import { cloneDeep } from 'lodash'
import SummaryReport from './components/SummaryReport'
import { menuDateOptionFilter } from 'helpers/constanst'
import MerchantRevenueReport from './components/MerchantRevenueReport'
import ProductRevenueReport from './components/ProductRevenueReport'
import MonthRevenueReport from './components/MonthRevenueReport'
import CompareRevenueReport from './components/CompareRevenueReport'
import { selectCurrentUser } from 'Store/user/selector'
import { OverallDashboardReq } from 'Store/minirmx-dashboard/types'
import { getMasterProductAPI, getOverallDashboardAPI } from 'Store/minirmx-dashboard/api'
import {
  selectMasterProduct,
  selectOverallDashboard,
  selectOverallDashboardEvent,
} from 'Store/minirmx-dashboard/selector'
import InseeLogo from '../../assets/img/insee-logo.png'

type Props = {} & ReduxProps

const DashboardRmxOverall: React.FunctionComponent<Props> = props => {
  const { event, currentUser, data, masterProducts } = props
  const dispatch = useDispatch()

  const initFilter = {
    start_date: getLast1Month(),
    end_date: currentDate(),
    quarter: '',
    product: '',
    dateType: 'date',
  }
  const [filter, setFilter] = useState(cloneDeep(initFilter))

  const onGetMerchantSummaryDashboard = (): void => {
    const req: OverallDashboardReq = {
      str_no: filter.product,
    }
    if (filter.dateType === 'date') {
      req.start_date = filter.start_date ? toDateQuery(filter.start_date) : ''
      req.end_date = filter.end_date ? toDateQuery(filter.end_date) : ''
    } else {
      if (filter.quarter) {
        const resultQuater = renderDateFormQuater(filter.quarter)
        req.start_date = resultQuater.startDate
        req.end_date = resultQuater.endDate
      }
    }
    dispatch(getOverallDashboardAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const onGetMasterProducts = (): void => {
    dispatch(getMasterProductAPI({}, currentUser.accessToken))
  }

  const onClickSearch = () => {
    onGetMerchantSummaryDashboard()
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetMasterProducts()
      onGetMerchantSummaryDashboard()
    }
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const handleChangeQuater = (val: string) => {
    setFilter({
      ...filter,
      quarter: val,
    })
  }

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[8, 8]}>
        <Col xs={24} md={5}>
          <SelectItem
            name={'dateType'}
            label={''}
            isRequired={true}
            value={filter.dateType}
            menu={menuDateOptionFilter}
            placeHolder={'ค้นหาด้วย'}
            onChange={(val: any): void => onFilter('dateType', val)}
          />
        </Col>
        <Col xs={24} md={8}>
          {filter.dateType === 'date' ? (
            <RangeDateItem
              placeHolder={['วันที่ซื้อเริ่มต้น', 'สิ้นสุด']}
              onChange={handleChangeDate}
              startDate={filter.start_date}
              endDate={filter.end_date}
            />
          ) : (
            <QuaterPickerItem
              placeHolder={'เลือกไตรมาส'}
              onChange={handleChangeQuater}
              date={filter.quarter}
            />
          )}
        </Col>
        <Col xs={24} md={8}>
          <SelectItem
            name={'product'}
            label={''}
            isRequired={true}
            value={filter.product}
            menu={getMenuSelect(masterProducts, 'class_cy', 'str_no')}
            placeHolder={'ผลิตภัณฑ์'}
            onChange={(val: any): void => onFilter('product', val)}
          />
        </Col>
        <Col>
          <PrimaryButton icon={<SearchOutlined />} text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
        </Col>
      </Row>
    </FilterWrapper>
  )

  const logo = <img src={InseeLogo} width="200px" />
  const title = (
    <Space>
      แดชบอร์ดภาพรวม INSEE Mini RMX
      {logo}
    </Space>
  )

  return (
    <HomePageLayout selected="dashboard-rmx-overall" title={title} bgColor="#fff">
      <LoadingView isShow={event.IsLoading} />
      {FilterContent}
      <Row gutter={[42, 42]}>
        <Col md={24} xs={24}>
          <SummaryReport data={data?.total} />
        </Col>
        <Col md={12} xs={24}>
          <CompareRevenueReport data={data?.daily_volume || []} />
        </Col>
        <Col md={12} xs={24}>
          <Row gutter={[42, 42]}>
            <Col md={24} xs={24}>
              <MerchantRevenueReport datas={data?.volume_by_merchant || []} />
            </Col>
            <Col md={24} xs={24}>
              <ProductRevenueReport datas={data?.volume_by_product || []} />
            </Col>
            <Col md={24} xs={24}>
              <MonthRevenueReport datas={data?.monthly_volume || []} />
            </Col>
          </Row>
        </Col>
      </Row>
    </HomePageLayout>
  )
}

const FilterWrapper = styled.div`
  padding: 10px 0 20px 0;
`

const mapStateToProps = (state: RootState) => {
  return {
    token: userTokenSelector(state),
    event: selectOverallDashboardEvent(state),
    currentUser: selectCurrentUser(state),
    data: selectOverallDashboard(state),
    masterProducts: selectMasterProduct(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(DashboardRmxOverall)
